import { useState } from 'react';
import { DeliverySearch, WSHeartMark, Screen } from '../components/ui';
import { Icon } from '../components/Icon';

type LinkItem = { id: Screen; label: string; icon: any; desc: string };

const REPORTS: LinkItem[] = [
  { id: 'failed', label: 'Failed deliveries', icon: 'alert', desc: 'Where and why stops fail' },
  { id: 'difot', label: 'DIFOT', icon: 'clock', desc: 'Delivered in full, on time' },
  { id: 'driver_performance', label: 'Driver performance', icon: 'truck', desc: 'Overtime & shift trends' },
  { id: 'feedback', label: 'Customer feedback', icon: 'star', desc: 'Ratings & low scores' },
  { id: 'delivery_cost', label: 'Delivery cost', icon: 'dollar', desc: 'Cost per delivery' },
];

export function HomeScreen({
  onNav, isAdmin,
}: { onNav: (s: Screen) => void; isAdmin: boolean }) {
  const links: LinkItem[] = [
    ...REPORTS,
    ...(isAdmin ? [{ id: 'board_report' as Screen, label: 'Board report', icon: 'grid', desc: 'Leadership headline view' }] : []),
  ];

  return (
    <div
      className="ws-fadein ws-scroll"
      style={{
        height: '100vh', overflow: 'auto', background: 'var(--ws-bone)',
        display: 'flex', flexDirection: 'column',
      }}
    >
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', padding: '48px 32px',
      }}>
        <div style={{ width: '100%', maxWidth: 640, textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 18 }}>
            <WSHeartMark size={46} />
          </div>
          <div className="ws-eyebrow-brand" style={{ marginBottom: 14 }}>
            Locate2u · Reporting Portal
          </div>
          <h1 className="ws-display-thin" style={{ fontSize: 46, margin: '0 0 12px', color: 'var(--ws-ink)' }}>
            Find a delivery
          </h1>
          <p style={{ fontSize: 15, color: 'var(--ws-mute)', margin: '0 0 28px', lineHeight: 1.55 }}>
            Search by reference to jump straight to a delivery in Locate2u, or open a report below.
          </p>

          <DeliverySearch variant="hero" />

          <div style={{ marginTop: 40, textAlign: 'left' }}>
            <div className="ws-eyebrow" style={{ marginBottom: 12 }}>Reports</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12 }}>
              {links.map((l, i) => <ReportCard key={l.id} item={l} index={i} onClick={() => onNav(l.id)} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ReportCard({ item, onClick, index = 0 }: { item: LinkItem; onClick: () => void; index?: number }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="ws-fadein"
      style={{
        display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start',
        textAlign: 'left', padding: '16px 16px 14px', cursor: 'pointer',
        background: 'var(--ws-paper)',
        border: `1px solid ${hover ? 'var(--ws-blue-tint)' : 'var(--ws-line-soft)'}`,
        borderRadius: 8, transition: 'border-color 140ms, transform 140ms',
        transform: hover ? 'translateY(-1px)' : 'none',
        animationDelay: `${Math.min(index, 12) * 35}ms`,
      }}
    >
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 32, height: 32, borderRadius: 7, background: 'var(--ws-blue-wash)',
      }}>
        <Icon name={item.icon} size={16} color="var(--ws-blue)" />
      </span>
      <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--ws-ink)' }}>{item.label}</span>
      <span style={{ fontSize: 11.5, color: 'var(--ws-mute)' }}>{item.desc}</span>
    </button>
  );
}
